import React from 'react'
import { ChampInner } from './styles'
import { getTeamIc } from '../../../Utils'
import { TeamGQL } from '../../../Api'
import { Spacer } from '../../Layout/Spacers/Spacers.styles'
import { Img } from '../../Image/Img'
const windowSize = window.innerWidth
type ChampionProps = {
  champion: TeamGQL
}

export const ChampionBox: React.FC<React.PropsWithChildren<ChampionProps>> = ({
  champion,
}) => {
  const shouldHideSpacer = windowSize < 960 ? true : false

  return (
    <>
      <Spacer h={78} hideSpacer={shouldHideSpacer} />
      <ChampInner>
        <div className="title">
          <h3>Champion</h3>
        </div>
        <div className='champTeam'>
          {champion && <Img src={getTeamIc(champion.fullName)} alt={`${champion.fullName} logo`} />}
        </div>
      </ChampInner>
    </>
  )
}
